import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AzmoonMaharatAnswer_Interface } from 'src/app/Interface/AzmoonMaharatAnswer_Interface';
import { AzmoonMaharatDetail_Files_Interface } from 'src/app/Interface/AzmoonMaharatDetail_Files_Interface';
import { AzmoonMaharatDetail_Interface } from 'src/app/Interface/AzmoonMaharatDetail_Interface';
import { AzmoonMaharatDetail_SignIn_Interface } from 'src/app/Interface/AzmoonMaharatDetail_SignIn_Interface';
import { AzmoonMaharatMain_Interface } from 'src/app/Interface/AzmoonMaharatMain_Interface';
import { AzmoonMaharatRequest_Interface } from 'src/app/Interface/AzmoonMaharatRequest_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AzmoonMaharatService {

  constructor(private http: HttpClient) { }


  GetRecord(Token: String): Observable<Array<AzmoonMaharatMain_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/AzmoonMaharat?token=" + Token).pipe(
      map(data => {
        return data as Array<AzmoonMaharatMain_Interface>
      })
    )
  }

  GetActiveList(Token: String): Observable<Array<AzmoonMaharatMain_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/AzmoonMaharat/GetActiveList?token=" + Token).pipe(
      map(data => {
        return data as Array<AzmoonMaharatMain_Interface>
      })
    )
  }

  AddAzmoonMaharat(model: AzmoonMaharatMain_Interface, Token: String): Observable<AzmoonMaharatMain_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id: model.id,
      title: model.title,
      code: model.code,
      del: false,
      username: Token,
    }


    return this.http.post(environment.BaseUrl + "Daro/AzmoonMaharat/AddEdit", body, { headers }).pipe(
      map(data => {
        return data as AzmoonMaharatMain_Interface
      })
    )

  }

  DeleteAzmoonMaharat(id: number,  Token: String): Observable<AzmoonMaharatMain_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/AzmoonMaharat/Delete?id=" + id 

      + "&token=" + Token).pipe(
      map(data => {
        return data as AzmoonMaharatMain_Interface
      })
    )

  }





  GetDetail(id: Number, Token: String): Observable<Array<AzmoonMaharatDetail_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/AzmoonMaharat/GetDetail?token=" + Token
      + "&id=" + id).pipe(
        map(data => {
          return data as Array<AzmoonMaharatDetail_Interface>
        })
      )
  }

  AddEditDetail(model: AzmoonMaharatDetail_Interface,
    main_id: Number,
    files: Array<AzmoonMaharatDetail_Files_Interface>,
    Token: String): Observable<AzmoonMaharatDetail_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id: model.id,
      title: model.title,
      startDate: model.startDate,
      endDate: model.endDate,
      main_id: main_id,
      files: files,
      del: false,
      username: Token,
    }


    return this.http.post(environment.BaseUrl + "Daro/AzmoonMaharat/AddEditDetail", body, { headers }).pipe(
      map(data => {
        return data as AzmoonMaharatDetail_Interface
      })
    )

  }

  DeleteDetail(id: number, Token: String): Observable<AzmoonMaharatDetail_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/AzmoonMaharat/DeleteDetail?id=" + id + "&token=" + Token).pipe(
      map(data => {
        return data as AzmoonMaharatDetail_Interface
      })
    )

  }


  uploadFile(body) {

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/AzmoonMaharat/Upload?", body).pipe(
      map(data => {

        return data
      })
    )
  }






  GetRequestCalender(Token: String): Observable<Array<AzmoonMaharatRequest_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/AzmoonMaharat/GetRequestCalender?token=" + Token).pipe(
      map(data => {
        return data as Array<AzmoonMaharatRequest_Interface>
      })
    )
  }

  SubmitRequest(Token: String, id: number): Observable<Array<AzmoonMaharatMain_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/AzmoonMaharat/SubmitRequest?token=" + Token
      + "&id=" + id).pipe(
        map(data => {
          return data as Array<AzmoonMaharatMain_Interface>
        })
      )
  }

  DeleteRequest(id: number,dsc: String, Token: String): Observable<AzmoonMaharatMain_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/AzmoonMaharat/DeleteRequest?id=" + id 
      + "&dsc=" + dsc
      + "&token=" + Token).pipe(
      map(data => {
        return data as AzmoonMaharatMain_Interface
      })
    )

  }

  EditRequest(id: number,code: String, Token: String): Observable<AzmoonMaharatMain_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/AzmoonMaharat/EditRequest?id=" + id 
      + "&code=" + code
      + "&token=" + Token).pipe(
      map(data => {
        return data as AzmoonMaharatMain_Interface
      })
    )

  }



  GetSignIn(filterType:number,Token: String): Observable<Array<AzmoonMaharatDetail_SignIn_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/AzmoonMaharat/GetSignIn?token=" + Token
      + "&filterType=" + filterType).pipe(
      map(data => {
        return data as Array<AzmoonMaharatDetail_SignIn_Interface>
      })
    )
  }

  GetSignInDetail(id: Number, Token: String): Observable<Array<AzmoonMaharatDetail_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/AzmoonMaharat/GetSignInDetail?token=" + Token
      + "&id=" + id).pipe(
        map(data => {
          return data as Array<AzmoonMaharatDetail_Interface>
        })
      )
  }

  SubmitRequestSignIn(id: Number, startdate: String, enddate: String, Token: String): Observable<Array<AzmoonMaharatDetail_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/AzmoonMaharat/SubmitRequestSignIn?token=" + Token
      + "&startdate=" + startdate
      + "&enddate=" + enddate
      + "&id=" + id).pipe(
        map(data => {
          return data as Array<AzmoonMaharatDetail_Interface>
        })
      )
  }

  SubmitRequestSignInFile(id: Number, title: String, filesrc: String, Token: String): Observable<Array<AzmoonMaharatDetail_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/AzmoonMaharat/SubmitRequestSignInFile?token=" + Token
      + "&title=" + title
      + "&filesrc=" + filesrc
      + "&id=" + id).pipe(
        map(data => {
          return data as Array<AzmoonMaharatDetail_Interface>
        })
      )
  }

  DeleteRequestSignInFile(id: Number, Token: String): Observable<Array<AzmoonMaharatDetail_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/AzmoonMaharat/DeleteRequestSignInFile?token=" + Token
      + "&id=" + id).pipe(
        map(data => {
          return data as Array<AzmoonMaharatDetail_Interface>
        })
      )
  }




  GetSignInCustomer(Token: String): Observable<Array<AzmoonMaharatRequest_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/AzmoonMaharat/GetSignInCustomer?token=" + Token).pipe(
      map(data => {
        return data as Array<AzmoonMaharatRequest_Interface>
      })
    )
  }

  SubmitRequestCustomerSignIn(id: Number,Token: String): Observable<Array<AzmoonMaharatRequest_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/AzmoonMaharat/SubmitRequestCustomerSignIn?token=" + Token
      + "&id=" + id).pipe(
      map(data => {
        return data as Array<AzmoonMaharatRequest_Interface>
      })
    )
  }


  SubmitRequestCustomerSignInFile(id: Number, title: String, filesrc: String, Token: String): Observable<Array<AzmoonMaharatDetail_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/AzmoonMaharat/SubmitRequestCustomerSignInFile?token=" + Token
      + "&title=" + title
      + "&filesrc=" + filesrc
      + "&id=" + id).pipe(
        map(data => {
          return data as Array<AzmoonMaharatDetail_Interface>
        })
      )
  }

  DeleteRequestCustomerSignInFile(id: Number, Token: String): Observable<Array<AzmoonMaharatDetail_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/AzmoonMaharat/DeleteRequestCustomerSignInFile?token=" + Token
      + "&id=" + id).pipe(
        map(data => {
          return data as Array<AzmoonMaharatDetail_Interface>
        })
      )
  }



  GetSignInCustomerConfirm(Token: String): Observable<Array<AzmoonMaharatAnswer_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/AzmoonMaharat/GetSignInCustomerConfirm?token=" + Token).pipe(
      map(data => {
        return data as Array<AzmoonMaharatAnswer_Interface>
      })
    )
  }

  SubmitSignInCustomerConfirm(id: Number,
    confirm: Number,
    dsc: String, 
    Token: String): Observable<Array<AzmoonMaharatDetail_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/AzmoonMaharat/SubmitSignInCustomerConfirm?token=" + Token
      + "&confirm=" + confirm
      + "&dsc=" + dsc
      + "&id=" + id).pipe(
        map(data => {
          return data as Array<AzmoonMaharatDetail_Interface>
        })
      )
  }


}
